import { render, staticRenderFns } from "./NotInServe.vue?vue&type=template&id=1f43ba0c&scoped=true&"
import script from "./NotInServe.vue?vue&type=script&lang=js&"
export * from "./NotInServe.vue?vue&type=script&lang=js&"
import style0 from "./NotInServe.vue?vue&type=style&index=0&id=1f43ba0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f43ba0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
